import _classCallCheck from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { eventHub } from '@miro-site/analytics';
import { StatFlags } from '@mirohq-internal/stats-analytics/dist/lib/StatTypes';

/**
 * This plugin is used to send analytics events to the event hub.
 * It uses stats-analytics package behind the scenes.
 * @see https://github.com/miroapp-dev/stats-analytics
 */
export var EventHubAnalyticsProviderPlugin = /*#__PURE__*/function () {
  function EventHubAnalyticsProviderPlugin() {
    _classCallCheck(this, EventHubAnalyticsProviderPlugin);

    _defineProperty(this, "name", 'eventhub');
  }

  _createClass(EventHubAnalyticsProviderPlugin, [{
    key: "track",
    value: function track(data) {
      /**
       * In case of error, batched events aren't cleared and keep trying every 1 second.
       * This is a workaround to send events immediately in development mode and in case of error we just ignore it.
       */
      var flags = false ? StatFlags.SendImmediately : StatFlags.SendInBatch;
      eventHub === null || eventHub === void 0 ? void 0 : eventHub.track(data.payload.event, data.payload.properties, flags);
    }
  }, {
    key: "identify",
    value: function identify(data) {
      eventHub === null || eventHub === void 0 ? void 0 : eventHub.identify(data.payload.userId);
    }
  }, {
    key: "page",
    value: function page() {
      eventHub === null || eventHub === void 0 ? void 0 : eventHub.page();
    }
  }]);

  return EventHubAnalyticsProviderPlugin;
}();